import { useEffect, useState } from "react";

const MOBILE_BREAKPOINT_PX = 640;

/**
 * Tracks whether the viewport is below the mobile breakpoint (mirrors
 * Tailwind's `sm` breakpoint at 640px). Used to branch entire layout trees
 * instead of toggling CSS visibility, so stateful panes (data fetching,
 * polling, live-channel subscriptions) never mount twice.
 *
 * @returns {boolean}
 */
export function useIsMobile() {
  const query = `(max-width: ${MOBILE_BREAKPOINT_PX - 1}px)`;
  const [isMobile, setIsMobile] = useState(() => window.matchMedia(query).matches);

  useEffect(() => {
    const mql = window.matchMedia(query);
    const handleChange = (e) => setIsMobile(e.matches);
    mql.addEventListener("change", handleChange);
    return () => mql.removeEventListener("change", handleChange);
  }, [query]);

  return isMobile;
}

export default useIsMobile;
